(function () {
  function setText(root, selector, value) {
    var node = root.querySelector(selector);
    if (node) node.textContent = value || "";
  }

  function setImage(root, imgSelector, url, alt) {
    if (!url) return;
    var img = root.querySelector(imgSelector);
    if (!img) return;

    /* Remove srcset to prevent browser from using a smaller cached variant */
    img.removeAttribute("srcset");
    img.removeAttribute("sizes");
    img.src = url;
    if (alt) img.alt = alt;
  }

  function initOwnerEvents(root) {
    var dots = Array.prototype.slice.call(root.querySelectorAll("[data-rvrn-event-dot]"));
    if (!dots.length) return;

    var autoplay = root.getAttribute("data-autoplay") === "true";
    var interval = parseInt(root.getAttribute("data-interval"), 10) || 5000;
    var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var progress = root.querySelector("[data-rvrn-event-progress]");
    var link = root.querySelector("[data-rvrn-event-link]");
    var timer = null;
    var activeIndex = 0;

    function updateProgress() {
      if (!progress) return;
      progress.style.transitionDuration = "0ms";
      progress.style.width = "0";

      if (!autoplay || reducedMotion) return;

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          progress.style.transitionDuration = interval + "ms";
          progress.style.width = "100%";
        });
      });
    }

    function activate(index) {
      var dot = dots[index];
      if (!dot) return;

      activeIndex = index;
      root.classList.add("is-changing");
      dots.forEach(function (item) {
        item.classList.toggle("is-active", item === dot);
      });

      var title = dot.getAttribute("data-title") || "";
      var award = dot.getAttribute("data-award") || "";
      var linkUrl = dot.getAttribute("data-link") || "#";
      var mainUrl = dot.getAttribute("data-main") || "";
      var wheelUrl = dot.getAttribute("data-wheel") || "";
      var proofUrl = dot.getAttribute("data-proof") || "";

      setText(root, "[data-rvrn-event-title]", title);
      setText(root, "[data-rvrn-event-vehicle]", dot.getAttribute("data-vehicle"));
      setText(root, "[data-rvrn-event-date]", dot.getAttribute("data-date"));
      setText(root, "[data-rvrn-event-location]", dot.getAttribute("data-location"));
      setText(root, "[data-rvrn-event-model]", dot.getAttribute("data-model"));
      setText(root, "[data-rvrn-event-size]", dot.getAttribute("data-size"));
      setText(root, "[data-rvrn-event-finish]", dot.getAttribute("data-finish"));

      var awardNode = root.querySelector("[data-rvrn-event-award]");
      if (awardNode) {
        awardNode.textContent = award;
        awardNode.classList.toggle("is-hidden", !award);
      }

      if (link) link.href = linkUrl;

      setText(root, "[data-rvrn-event-counter]", String(index + 1).padStart(2, "0") + " / " + String(dots.length).padStart(2, "0"));

      /* Update images — handle both direct <img> tags and rvrn-responsive-media output */
      setImage(root, ".rvrn-owner-events-reel__main-img", mainUrl, title);
      setImage(root, "[data-rvrn-event-img=\"wheel\"]", wheelUrl, title);
      setImage(root, "[data-rvrn-event-img=\"proof\"]", proofUrl, title);

      window.setTimeout(function () {
        root.classList.remove("is-changing");
      }, 150);

      updateProgress();
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
      if (progress) {
        progress.style.transitionDuration = "0ms";
        progress.style.width = "0";
      }
    }

    function play() {
      stop();
      if (!autoplay || reducedMotion || dots.length < 2) return;
      updateProgress();
      timer = window.setInterval(function () {
        activate((activeIndex + 1) % dots.length);
      }, interval);
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener("click", function () {
        activate(index);
        play();
      });
      dot.addEventListener("mouseenter", function () {
        activate(index);
        stop();
      });
      dot.addEventListener("focus", function () {
        activate(index);
        stop();
      });
    });

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", play);
    root.addEventListener("focusout", function () {
      if (!root.contains(document.activeElement)) play();
    });

    activate(0);
    play();
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-rvrn-owner-events]").forEach(initOwnerEvents);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
